import { motion, useAnimation, useInView } from "framer-motion";
import { useEffect, useRef } from "react";

const FadeInWhenVisible = ({
  children,
  index = 0,
  staggeredInitial = false,
  staggerDelay = 0.01,
}: {
  children: React.ReactNode;
  index?: number;
  staggeredInitial?: boolean;
  staggerDelay?: number;
}) => {
  const controls = useAnimation();
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: false,
    margin: "0px 0px -100px 0px",
  });

  useEffect(() => {
  if (isInView) {
    const delay = staggeredInitial ? index * staggerDelay : 0;
    controls.start("visible", { delay });
  } else {
    // Reset animation when going out of view
    controls.set("hidden");
  }
}, [isInView, controls, index, staggeredInitial]);

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={controls}
      variants={{
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0 },
      }}
      transition={{ duration: 0.1, ease: "easeOut" }}
    >
      {children}
    </motion.div>
  );
};

export default FadeInWhenVisible;
